const state = {
  should_recaptcha: false,
  recaptcha_site_key: null
};

const actions = {
  initData({ dispatch }, recaptcha_setting = {}){
    dispatch('setShouldRecaptcha', recaptcha_setting.should_recaptcha);
    dispatch('setRecaptchaSiteKey', recaptcha_setting.recaptcha_site_key);
  },
  setShouldRecaptcha({ commit }, value){
    commit('SET_SHOULD_RECAPTCHA', value);
  },
  setRecaptchaSiteKey({ commit }, value){
    commit('SET_RECAPTCHA_SITE_KEY', value);
  },
};

const mutations = {
  SET_SHOULD_RECAPTCHA(state, value){
    state.should_recaptcha = value;
  },
  SET_RECAPTCHA_SITE_KEY(state, value){
    state.recaptcha_site_key = value;
  },
};

export default {
  namespaced: true,
  state: () => state,
  actions,
  mutations
};